<div class="lg:flex justify-center md:justify-start px-container lg:px-64 align-middle hero">
    <section class="flex lg:flex-row flex-col lg:justify-between lg:items-center gap-16 lg:gap-8 lg:p-8 w-full">
        <div class="flex flex-col items-center gap-6">            
            <app-date-spettacolo [spettacolo]="spettacolo" colore="dark" class="w-full"></app-date-spettacolo>        
            <div class="w-full">
                <h1 class="text-3xl lg:text-5xl uppercase">{{spettacolo?.spettacolo}}</h1>
                <span class="font-mono lg:text-xl italic" [innerHTML]="spettacolo?.compagnia"></span>
            </div>
            <div class="self-start">
                <app-button-spettacolo classi="block text-center btn btn-primary btn-sm" [spettacolo]="spettacolo" [calendario]="spettacolo?.calendario || []" *ngIf="!carica"></app-button-spettacolo>
            </div>
        </div>
    </section>
</div>

<div #div_image class="lg:block w-full image bg-center bg-no-repeat" *ngIf="!carica">
    <img #img class="w-full h-full object-cover" [src]="(spettacolo?.img_copertina + '?type=spettacolo' | image)" (error)="img.style.display = 'none'; div_image.style.backgroundImage = 'url(/assets/images/logo.svg)'; div_image.style.backgroundSize = '25%';">
</div>

<!-- INTRO -->
<section class="flex flex-col gap-8 px-container py-16" id="info">
    <div class="mb-10">
        <span class="date-flag">Intro</span>
    </div>
    <div class="flex lg:flex-row flex-col gap-8">
        <div class="w-full lg:w-1/2">
            <h1 class="text-3xl lg:text-5xl">{{spettacolo?.compagnia ? spettacolo?.compagnia : spettacolo?.spettacolo}}</h1>

            <!-- PRENOTABILE DAL -->
            <div class="flex items-center mt-8 lg:w-2/3 w-full text-xl" *ngIf="spettacolo?.prenotabile_dal">
                <span class="grow-0 pe-4">In vendita dal {{spettacolo?.prenotabile_dal | date: 'dd MMM yyyy' | titlecase }}</span>
                <ng-container *ngIf="spettacolo?.prenotabile_dal_orario">
                    <div class="rounded h-[2px] grow bg-dark"></div>
                    <span class="grow-0 ps-4 ">h {{ spettacolo?.prenotabile_dal_orario }}</span>
                </ng-container>
            </div>
            <!-- PRENOTABILE DAL -->

            <!-- DATE CALENDARIO -->
            <ng-container *ngIf="spettacolo?.calendario!.length > 0">
                <h1 class="text-2xl lg:text-3xl mt-8">Orari</h1>
                <div class="flex items-center mt-4 lg:w-2/3 w-full text-base" *ngFor="let data_calendario of spettacolo?.calendario">
                    <span class="grow-0 pe-4 ">{{data_calendario?.data | date: 'EEE dd MMM yyyy' | titlecase }}</span>
                    <div class="rounded h-[2px] grow bg-dark"></div>
                    <span class="grow-0 ps-4 ">h {{ data_calendario?.orario }}</span>
                </div>
            </ng-container>
            <!-- DATE CALENDARIO -->
            
        </div>
        <div class="w-full lg:w-1/2 h-full">
            <p class="lg:text-lg font-mono" [innerHTML]="spettacolo?.descrizione"></p>
        </div>
    </div>
</section>
<!-- INTRO -->

<hr *ngIf="casts.length > 0">

<!-- CAST -->
<section class="px-container py-16" *ngIf="casts.length > 0">
    <h1 class="text-4xl lg:text-5xl">Cast</h1>
    <div class="flex lg:flex-row flex-col gap-8 mt-12">
        <ng-container *ngFor="let cast of casts">

            <div class="lg:w-1/5 w-full" *ngIf="cast">
                <h1 class="mb-2 lg:mb-4 font-medium font-mono italic text-xl">{{cast}}</h1>
                <ul class="font-mono italic" *ngFor="let cast_items of casts | ruoloCastSpettacolo: spettacolo?.cast!: (cast || '')">
                    <li>{{cast_items.cast}}</li>
                </ul>
            </div>

        </ng-container>

    </div>

</section>
<!-- CAST -->

<hr *ngIf="(spettacolo?.prezzi || []).length > 0 && (spettacolo?.link_webshop?.length! > 0 || spettacolo?.link_custom?.length! > 0)">

<!-- BIGLIETTI -->
<section class="px-container py-16" *ngIf="(spettacolo?.prezzi || []).length > 0 && (spettacolo?.link_webshop?.length! > 0 || spettacolo?.link_custom?.length! > 0)">
    <h1 class="text-4xl lg:text-5xl">Biglietti</h1>

    <!--  PREZZI -->
    <div class="flex flex-col gap-8 mt-12" >

        <!-- DESCRIZIONE PREZZI -->
        <div class="w-full" *ngIf="spettacolo?.descrizione_prezzi?.length! > 0">
            <p class="font-mono lg:text-justify" [innerHTML]="spettacolo?.descrizione_prezzi"></p>
        </div>
        <!-- DESCRIZIONE PREZZI -->

        <div class="flex lg:flex-row flex-col items-center gap-8 w-full">            
            <div class="flex flex-col gap-2 w-full" *ngIf="prezziLength('prezzo_webshop') > 0">
                <h1 class="mb-4 font-medium font-mono italic lg:text-xl lg:text-right">Teatro Colosseo</h1>
                <ul class="font-mono italic" *ngFor="let prezzo of spettacolo?.prezzi; let i = index">
                    <li class="flex justify-between"><span>{{prezzo.settore}}</span><span>{{prezzo.prezzo_webshop | currency: 'EUR'}}</span></li>
                </ul>                
            </div>
            <div class="flex flex-col gap-2 w-full" *ngIf="prezziLength('prezzo_ticketone') > 0">
                <h1 class="mb-4 font-medium font-mono italic lg:text-xl lg:text-right">TicketOne</h1>
                <ul class="font-mono italic" *ngFor="let prezzo of spettacolo?.prezzi; let i = index">
                    <li><span>{{prezzo.settore}}</span><span>{{prezzo.prezzo_ticketone | currency: 'EUR'}}</span></li>
                </ul>                
            </div>            
        </div>

    </div>
    <!-- PREZZI -->    

    <div class="flex justify-center lg:justify-start mt-12">
        <app-button-spettacolo classi="block text-center btn btn-primary btn-sm" [spettacolo]="spettacolo" [calendario]="spettacolo?.calendario || []" *ngIf="!carica"></app-button-spettacolo>
    </div>

</section>
<!-- BIGLIETTI -->

<hr *ngIf="(spettacolo?.timeline || []).length > 0">

<!-- TIMELINE -->
<section class="px-container py-16" *ngIf="(spettacolo?.timeline || []).length > 0">
    <h1 class="text-4xl lg:text-5xl mb-12">Timeline</h1>
    <p-stepper [activeStep]="0">
        <p-stepperPanel *ngFor="let data_timeline of spettacolo?.timeline; let i = index">
            <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
                <button class="border-none focus-visible:outline-none hover:text-accent transition-colors duration-300" [class.hidden]="spettacolo?.timeline!.length == 1" (click)="onClick.emit()">
                    <i class="bi bi-circle-fill lg:text-7xl text-5xl"></i>
                </button>
            </ng-template>
            <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
                <div class="contenuto flex items-center lg:gap-16 gap-8 flex-col-reverse" [ngClass]="{'mt-8': spettacolo?.timeline!.length > 1, 'lg:flex-row': index % 2 == 0, 'lg:flex-row-reverse': index % 2 !== 0}">
                    <div class="testo lg:w-1/2 w-full">
                        <div class="fade-in-2nd">
                            <h1 class="text-3xl lg:text-4xl mb-4 font-sans text-black">{{data_timeline.titolo}}</h1>
                            <h3 class="text-xl mb-4 font-sans text-black">{{data_timeline?.data | date: 'dd/MM/yyyy'}}</h3>
                        </div>
                        <p [innerHTML]="data_timeline.descrizione" class="fade-in-3rd"></p>
                    </div>
                    <div class="immagine lg:w-1/2 w-full fade-in">
                        <img [src]="(data_timeline?.immagine + '?type=spettacolo' | image)" alt="" class="object-contain h-[60vh] w-full" *ngIf="!show_pdf_timeline">                        
                        <a class="image-pdf relative " [href]="pdf_timeline | pdf" target="_blank" *ngIf="show_pdf_timeline">
                            <img [src]="(image_pdf_timeline + '?type=spettacolo' | image)" alt="" class="object-contain h-[60vh] w-full hover:grayscale duration-300 cursor-pointer hover:scale-[1.03]">
                            <i class="bi bi-file-earmark-pdf text-7xl absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]"></i>
                        </a>
                        
                    </div>
                </div>
            </ng-template>
        </p-stepperPanel>
    </p-stepper>
</section>
<!-- TIMELINE -->

<hr *ngIf="(spettacolo?.galleria || []).length > 0">

<!-- GALLERIA -->
<ng-container *ngIf="(spettacolo?.galleria || []).length > 0">
    <section class="px-container pt-16">
        <h1 class="text-4xl lg:text-5xl">Gallery</h1>
    </section>

    <section class="mb-8 py-16">
        <app-slider [loop]="false" [navigation]="(spettacolo?.galleria || []).length > 1" [grabCursor]="true" [sliderLength]="(spettacolo?.galleria || []).length"  [breakpoints]="{'0.00': {slidesPerView: 1, spaceBetween: 10 }, '@0.75': { slidesPerView: 2, spaceBetween: 10 }, '@1.00': { slidesPerView: 2, spaceBetween: 10 }, '@1.50': { slidesPerView: 2.5, spaceBetween: 10 }}">
            <swiper-slide [lazy]="true" *ngFor="let file of spettacolo?.galleria" class="flex h-[50vh] image-video-gallery">
                <div class="image-video-gallery-bg" [style.background-image]="'url(' + (file?.file + '?type=spettacolo' | image) + ')'"></div>
                <ng-container *ngIf="file.type === 'image'">
                    <img [src]="(file?.file + '?type=spettacolo' | image)" alt="" class="object-contain bg-transparent cursor-pointer" (click)="openImg(popUpImage)">
                    <ng-template #popUpImage>
                        <div class="text-right">
                            <button (click)="popupImage?.close()" class="me-[5%] lg:me-0 text-4xl btn-primary btn-sm focus-visible:outline-none">&times;</button>
                            <img [src]="(file?.file + '?type=spettacolo' | image)" alt="" class="mx-auto max-w-[90%] lg:max-w-[100%] max-h-[90vh]">
                        </div>
                    </ng-template>
                </ng-container>
                <ng-container *ngIf="file.type !== 'image'">                    
                    <app-video-galleria-spettacolo [spettacolo]="spettacolo" [file]="file" class="h-full"></app-video-galleria-spettacolo>
                </ng-container>
            </swiper-slide>
        </app-slider>
    </section>
</ng-container>
<!-- GALLERIA -->

<!-- ALTRI SPETTACOLI -->
<section class="bg-light px-container pt-16" *ngIf="spettacoli.length > 0">
    <h1 class="mt-8 text-4xl text-center lg:text-5xl">Potrebbe interessarti anche</h1>
</section>
<section class="bg-light px-container pt-8 pb-32" *ngIf="spettacoli.length > 0">
    <div class="grid lg:grid-cols-3">
        <div *ngFor="let spettacolo of spettacoli.slice(0, 3); let i = index">
            <app-box-stagione [spettacolo]="spettacolo" class="flex border-e-2 border-gray-300 lg:border-e-0 border-b-2 border-l-2 border-dashed h-full" [ngClass]="{'lg:!border-e-2': (i + 1) % 3 === 0, 'lg:border-t-2': (i + 1) <= 3, 'border-t-2': i == 0, '!border-e-2': spettacoli.length == (i + 1), 'lg:border-l-2': i % 2 != 0, 'bordo': (i + 1) > 3 && (i + 1) % 3 !== 0}"></app-box-stagione>
        </div>
    </div>
</section>
<!-- ALTRI SPETTACOLI -->